import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon } from 'lucide-react';
import { ContactFormPopup } from './ContactFormPopup';
export function FloatingContact() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  return <>
      <div className="fixed bottom-6 right-6 z-50" data-id="element-161">
        <motion.button onClick={() => setIsPopupOpen(true)} whileHover={{
        scale: 1.1
      }} whileTap={{
        scale: 0.9
      }} className="w-14 h-14 rounded-full shadow-2xl flex items-center justify-center transition-transform" style={{
        backgroundColor: 'var(--accent)',
        color: '#FFFFFF'
      }} data-id="element-162">
          <MessageCircleIcon className="w-6 h-6" data-id="element-163" />
        </motion.button>
      </div>

      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-164" />
    </>;
}